<template>
  <div class="container">
    <div class="selectconditons">
      <a-row :gutter="24">
        <a-button type="primary" icon="plus" style="margin-left: 1%" @click="openAddModal()">新增方案</a-button>
      </a-row>
    </div>
    <div class="selectresulttable">
      <a-table
        :columns="columns"
        :data-source="data"
        :pagination="ipagination"
        :loading="loading"
        :scroll="{ x: 1000 }"
        bordered
      >
        <span slot="isDefault" slot-scope="text">
          <a-tag :color="text === 1 ? 'green' : ''">{{ text === 1 ? '是' : '否' }}</a-tag>
        </span>
        <span slot="action" slot-scope="text, record">
          <a-button type="link" @click="openAddModal(record)" size="small" style="margin-right: 3px">修改</a-button>
          <a-button
            v-if="record.isDefault !== 1"
            type="link"
            @click="setDefault(record)"
            size="small"
            style="margin-right: 3px">设为默认</a-button>
        </span>
      </a-table>
      <div class="pageBar">
        <a-pagination
          style="margin-top: 1%; float: right"
          size="small"
          :current="ipagination.current"
          :total="ipagination.total"
          :show-total="(total, range) => `${range[0]}-${range[1]} 共 ${total} 条`"
          show-size-changer
          show-quick-jumper
          :showSizeChanger="true"
          :pageSize="ipagination.pageSize"
          :pageSizeOptions="ipagination.pageSizeOptions"
          @change="onChange"
          @showSizeChange="showSizeChange"
        />
      </div>
    </div>
    <platform-scheme-modal ref="platformSchemeModal" @ok="modalFormOk"></platform-scheme-modal>
  </div>
</template>

<script>
import { getAction, putAction } from '@/api/manage'
import PlatformSchemeModal from './modules/PlatformSchemeModal'

const columns = [
  {
    title: '方案名称',
    dataIndex: 'schemeName',
    key: 'schemeName',
    width: 150
  },
  {
    title: '方案描述',
    dataIndex: 'description',
    key: 'description'
  },
  {
    title: '是否默认',
    dataIndex: 'isDefault',
    key: 'isDefault',
    width: 100,
    scopedSlots: { customRender: 'isDefault' }
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    key: 'createTime',
    width: 150
  },
  {
    title: '更新时间',
    dataIndex: 'updateTime',
    key: 'updateTime',
    width: 150
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: { customRender: 'action' },
    width: 200
  }
]

export default {
  name: 'PlatformScheme',
  components: {
    PlatformSchemeModal
  },
  data() {
    return {
      columns,
      data: [],
      loading: false,
      url: {
        list: '/message/platform/scheme/list',
        setDefault: '/message/platform/scheme/default'
      },
      ipagination: {
        current: 1,
        total: 0,
        pageSize: 10,
        pageNo: 1,
        showTotal: (total, range) => `${range[0]}-${range[1]} 共 ${total} 条`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showQuickJumper: true
      }
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      const params = {
        pageNo: this.ipagination.current,
        pageSize: this.ipagination.pageSize
      }

      this.loading = true
      getAction(this.url.list, params).then(res => {
        if (res.success) {
          this.data = res.result.records
          this.ipagination.total = res.result.total
          this.ipagination.current = res.result.current
        } else {
          this.$message.error(res.message)
        }
        this.loading = false
      })
    },
    openAddModal(record) {
      this.$refs.platformSchemeModal.edit(record)
    },
    modalFormOk() {
      this.loadData()
    },
    setDefault(record) {
      putAction(`${this.url.setDefault}/${record.id}`).then(res => {
        if (res.success) {
          this.$message.success(res.message)
          this.loadData()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    handleTableChange(pagination) {
      this.ipagination = pagination
      this.loadData()
    },
    onChange(page, pageSize) {
      this.pagination.current = page
      this.pagination.pageSize = pageSize
      this.loadData()
    },
    showSizeChange(current, size) {
      this.pagination.current = current
      this.pagination.pageSize = size
      this.loadData()
    }
  }
}
</script>

<style scoped>
.container {
  background-color: #ffffff;
  height: 100%;
  width: 100%;
}
.selectconditons {
  padding-top: 1%;
  padding-left: 1%;
  background-color: #ffffff;
}
.selectresulttable {
  padding: 0.5%;
  background-color: #ffffff;
}
.pageBar {
  width: 100%;
  height: 3rem;
  background-color: #ffffff;
}
.titleLabel {
  float: right;
  padding-right: 10%;
}
.rowStyle {
  height: 100%;
  margin-top: 15px;
}
.width-100 {
  width: 100%;
}
</style>